// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class HallCallEligibilityMessage implements flatbuffers.IUnpackableObject<HallCallEligibilityMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): HallCallEligibilityMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsHallCallEligibilityMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: HallCallEligibilityMessage,
  ): HallCallEligibilityMessage {
    return (obj || new HallCallEligibilityMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsHallCallEligibilityMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: HallCallEligibilityMessage,
  ): HallCallEligibilityMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new HallCallEligibilityMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  configIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  controllerIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  downAuxFront(index: number): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? !!this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : false;
  }

  downAuxFrontLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  downAuxFrontArray(): Int8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return new Int8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  downAuxRear(index: number): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : false;
  }

  downAuxRearLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  downAuxRearArray(): Int8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return new Int8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  downMainFront(index: number): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : false;
  }

  downMainFrontLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  downMainFrontArray(): Int8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return new Int8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  downMainRear(index: number): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : false;
  }

  downMainRearLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  downMainRearArray(): Int8Array {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return new Int8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  upAuxFront(index: number): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : false;
  }

  upAuxFrontLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  upAuxFrontArray(): Int8Array {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return new Int8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  upAuxRear(index: number): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : false;
  }

  upAuxRearLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  upAuxRearArray(): Int8Array {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return new Int8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  upMainFront(index: number): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : false;
  }

  upMainFrontLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  upMainFrontArray(): Int8Array {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return new Int8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  upMainRear(index: number): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? !!this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : false;
  }

  upMainRearLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  upMainRearArray(): Int8Array {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return new Int8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  static startHallCallEligibilityMessage(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addConfigIndex(builder: flatbuffers.Builder, configIndex: number) {
    builder.addFieldInt32(0, configIndex, 0);
  }

  static addControllerIndex(builder: flatbuffers.Builder, controllerIndex: number) {
    builder.addFieldInt32(1, controllerIndex, 0);
  }

  static addDownAuxFront(builder: flatbuffers.Builder, downAuxFrontOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, downAuxFrontOffset, 0);
  }

  static createDownAuxFrontVector(
    builder: flatbuffers.Builder,
    data: boolean[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(+data[i]!);
    }
    return builder.endVector();
  }

  static startDownAuxFrontVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addDownAuxRear(builder: flatbuffers.Builder, downAuxRearOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, downAuxRearOffset, 0);
  }

  static createDownAuxRearVector(
    builder: flatbuffers.Builder,
    data: boolean[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(+data[i]!);
    }
    return builder.endVector();
  }

  static startDownAuxRearVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addDownMainFront(builder: flatbuffers.Builder, downMainFrontOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, downMainFrontOffset, 0);
  }

  static createDownMainFrontVector(
    builder: flatbuffers.Builder,
    data: boolean[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(+data[i]!);
    }
    return builder.endVector();
  }

  static startDownMainFrontVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addDownMainRear(builder: flatbuffers.Builder, downMainRearOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, downMainRearOffset, 0);
  }

  static createDownMainRearVector(
    builder: flatbuffers.Builder,
    data: boolean[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(+data[i]!);
    }
    return builder.endVector();
  }

  static startDownMainRearVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addUpAuxFront(builder: flatbuffers.Builder, upAuxFrontOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, upAuxFrontOffset, 0);
  }

  static createUpAuxFrontVector(builder: flatbuffers.Builder, data: boolean[]): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(+data[i]!);
    }
    return builder.endVector();
  }

  static startUpAuxFrontVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addUpAuxRear(builder: flatbuffers.Builder, upAuxRearOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, upAuxRearOffset, 0);
  }

  static createUpAuxRearVector(builder: flatbuffers.Builder, data: boolean[]): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(+data[i]!);
    }
    return builder.endVector();
  }

  static startUpAuxRearVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addUpMainFront(builder: flatbuffers.Builder, upMainFrontOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, upMainFrontOffset, 0);
  }

  static createUpMainFrontVector(
    builder: flatbuffers.Builder,
    data: boolean[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(+data[i]!);
    }
    return builder.endVector();
  }

  static startUpMainFrontVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addUpMainRear(builder: flatbuffers.Builder, upMainRearOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, upMainRearOffset, 0);
  }

  static createUpMainRearVector(builder: flatbuffers.Builder, data: boolean[]): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(+data[i]!);
    }
    return builder.endVector();
  }

  static startUpMainRearVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static endHallCallEligibilityMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 8); // down_aux_front
    builder.requiredField(offset, 10); // down_aux_rear
    builder.requiredField(offset, 12); // down_main_front
    builder.requiredField(offset, 14); // down_main_rear
    builder.requiredField(offset, 16); // up_aux_front
    builder.requiredField(offset, 18); // up_aux_rear
    builder.requiredField(offset, 20); // up_main_front
    builder.requiredField(offset, 22); // up_main_rear
    return offset;
  }

  static createHallCallEligibilityMessage(
    builder: flatbuffers.Builder,
    configIndex: number,
    controllerIndex: number,
    downAuxFrontOffset: flatbuffers.Offset,
    downAuxRearOffset: flatbuffers.Offset,
    downMainFrontOffset: flatbuffers.Offset,
    downMainRearOffset: flatbuffers.Offset,
    upAuxFrontOffset: flatbuffers.Offset,
    upAuxRearOffset: flatbuffers.Offset,
    upMainFrontOffset: flatbuffers.Offset,
    upMainRearOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    HallCallEligibilityMessage.startHallCallEligibilityMessage(builder);
    HallCallEligibilityMessage.addConfigIndex(builder, configIndex);
    HallCallEligibilityMessage.addControllerIndex(builder, controllerIndex);
    HallCallEligibilityMessage.addDownAuxFront(builder, downAuxFrontOffset);
    HallCallEligibilityMessage.addDownAuxRear(builder, downAuxRearOffset);
    HallCallEligibilityMessage.addDownMainFront(builder, downMainFrontOffset);
    HallCallEligibilityMessage.addDownMainRear(builder, downMainRearOffset);
    HallCallEligibilityMessage.addUpAuxFront(builder, upAuxFrontOffset);
    HallCallEligibilityMessage.addUpAuxRear(builder, upAuxRearOffset);
    HallCallEligibilityMessage.addUpMainFront(builder, upMainFrontOffset);
    HallCallEligibilityMessage.addUpMainRear(builder, upMainRearOffset);
    return HallCallEligibilityMessage.endHallCallEligibilityMessage(builder);
  }

  unpack(): HallCallEligibilityMessageT {
    return new HallCallEligibilityMessageT(
      this.configIndex(),
      this.controllerIndex(),
      this.bb!.createScalarList<boolean>(this.downAuxFront.bind(this), this.downAuxFrontLength()),
      this.bb!.createScalarList<boolean>(this.downAuxRear.bind(this), this.downAuxRearLength()),
      this.bb!.createScalarList<boolean>(this.downMainFront.bind(this), this.downMainFrontLength()),
      this.bb!.createScalarList<boolean>(this.downMainRear.bind(this), this.downMainRearLength()),
      this.bb!.createScalarList<boolean>(this.upAuxFront.bind(this), this.upAuxFrontLength()),
      this.bb!.createScalarList<boolean>(this.upAuxRear.bind(this), this.upAuxRearLength()),
      this.bb!.createScalarList<boolean>(this.upMainFront.bind(this), this.upMainFrontLength()),
      this.bb!.createScalarList<boolean>(this.upMainRear.bind(this), this.upMainRearLength()),
    );
  }

  unpackTo(_o: HallCallEligibilityMessageT): void {
    _o.configIndex = this.configIndex();
    _o.controllerIndex = this.controllerIndex();
    _o.downAuxFront = this.bb!.createScalarList<boolean>(
      this.downAuxFront.bind(this),
      this.downAuxFrontLength(),
    );
    _o.downAuxRear = this.bb!.createScalarList<boolean>(
      this.downAuxRear.bind(this),
      this.downAuxRearLength(),
    );
    _o.downMainFront = this.bb!.createScalarList<boolean>(
      this.downMainFront.bind(this),
      this.downMainFrontLength(),
    );
    _o.downMainRear = this.bb!.createScalarList<boolean>(
      this.downMainRear.bind(this),
      this.downMainRearLength(),
    );
    _o.upAuxFront = this.bb!.createScalarList<boolean>(
      this.upAuxFront.bind(this),
      this.upAuxFrontLength(),
    );
    _o.upAuxRear = this.bb!.createScalarList<boolean>(
      this.upAuxRear.bind(this),
      this.upAuxRearLength(),
    );
    _o.upMainFront = this.bb!.createScalarList<boolean>(
      this.upMainFront.bind(this),
      this.upMainFrontLength(),
    );
    _o.upMainRear = this.bb!.createScalarList<boolean>(
      this.upMainRear.bind(this),
      this.upMainRearLength(),
    );
  }

  unpackFields(...fields: string[]): HallCallEligibilityMessageT {
    const t = new HallCallEligibilityMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("config_index")) {
      t.configIndex = this.configIndex();
    }
    if (fieldSet.has("controller_index")) {
      t.controllerIndex = this.controllerIndex();
    }
    if (fieldSet.has("down_aux_front")) {
      t.downAuxFront = this.bb!.createScalarList<boolean>(
        this.downAuxFront.bind(this),
        this.downAuxFrontLength(),
      );
    }
    if (fieldSet.has("down_aux_rear")) {
      t.downAuxRear = this.bb!.createScalarList<boolean>(
        this.downAuxRear.bind(this),
        this.downAuxRearLength(),
      );
    }
    if (fieldSet.has("down_main_front")) {
      t.downMainFront = this.bb!.createScalarList<boolean>(
        this.downMainFront.bind(this),
        this.downMainFrontLength(),
      );
    }
    if (fieldSet.has("down_main_rear")) {
      t.downMainRear = this.bb!.createScalarList<boolean>(
        this.downMainRear.bind(this),
        this.downMainRearLength(),
      );
    }
    if (fieldSet.has("up_aux_front")) {
      t.upAuxFront = this.bb!.createScalarList<boolean>(
        this.upAuxFront.bind(this),
        this.upAuxFrontLength(),
      );
    }
    if (fieldSet.has("up_aux_rear")) {
      t.upAuxRear = this.bb!.createScalarList<boolean>(
        this.upAuxRear.bind(this),
        this.upAuxRearLength(),
      );
    }
    if (fieldSet.has("up_main_front")) {
      t.upMainFront = this.bb!.createScalarList<boolean>(
        this.upMainFront.bind(this),
        this.upMainFrontLength(),
      );
    }
    if (fieldSet.has("up_main_rear")) {
      t.upMainRear = this.bb!.createScalarList<boolean>(
        this.upMainRear.bind(this),
        this.upMainRearLength(),
      );
    }
    return t;
  }
}

export class HallCallEligibilityMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public configIndex: number = 0,
    public controllerIndex: number = 0,
    public downAuxFront: boolean[] = [],
    public downAuxRear: boolean[] = [],
    public downMainFront: boolean[] = [],
    public downMainRear: boolean[] = [],
    public upAuxFront: boolean[] = [],
    public upAuxRear: boolean[] = [],
    public upMainFront: boolean[] = [],
    public upMainRear: boolean[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.downAuxFront === null || this.downAuxFront === undefined) {
      throw new Error('Required field "down_aux_front" is not set');
    }
    if (this.downAuxRear === null || this.downAuxRear === undefined) {
      throw new Error('Required field "down_aux_rear" is not set');
    }
    if (this.downMainFront === null || this.downMainFront === undefined) {
      throw new Error('Required field "down_main_front" is not set');
    }
    if (this.downMainRear === null || this.downMainRear === undefined) {
      throw new Error('Required field "down_main_rear" is not set');
    }
    if (this.upAuxFront === null || this.upAuxFront === undefined) {
      throw new Error('Required field "up_aux_front" is not set');
    }
    if (this.upAuxRear === null || this.upAuxRear === undefined) {
      throw new Error('Required field "up_aux_rear" is not set');
    }
    if (this.upMainFront === null || this.upMainFront === undefined) {
      throw new Error('Required field "up_main_front" is not set');
    }
    if (this.upMainRear === null || this.upMainRear === undefined) {
      throw new Error('Required field "up_main_rear" is not set');
    }
    const downAuxFront = HallCallEligibilityMessage.createDownAuxFrontVector(
      builder,
      this.downAuxFront,
    );
    const downAuxRear = HallCallEligibilityMessage.createDownAuxRearVector(
      builder,
      this.downAuxRear,
    );
    const downMainFront = HallCallEligibilityMessage.createDownMainFrontVector(
      builder,
      this.downMainFront,
    );
    const downMainRear = HallCallEligibilityMessage.createDownMainRearVector(
      builder,
      this.downMainRear,
    );
    const upAuxFront = HallCallEligibilityMessage.createUpAuxFrontVector(builder, this.upAuxFront);
    const upAuxRear = HallCallEligibilityMessage.createUpAuxRearVector(builder, this.upAuxRear);
    const upMainFront = HallCallEligibilityMessage.createUpMainFrontVector(
      builder,
      this.upMainFront,
    );
    const upMainRear = HallCallEligibilityMessage.createUpMainRearVector(builder, this.upMainRear);

    return HallCallEligibilityMessage.createHallCallEligibilityMessage(
      builder,
      this.configIndex,
      this.controllerIndex,
      downAuxFront,
      downAuxRear,
      downMainFront,
      downMainRear,
      upAuxFront,
      upAuxRear,
      upMainFront,
      upMainRear,
    );
  }

  clone(): HallCallEligibilityMessageT {
    const obj = new HallCallEligibilityMessageT();
    obj.configIndex = this.configIndex;
    obj.controllerIndex = this.controllerIndex;
    obj.downAuxFront = [...this.downAuxFront];
    obj.downAuxRear = [...this.downAuxRear];
    obj.downMainFront = [...this.downMainFront];
    obj.downMainRear = [...this.downMainRear];
    obj.upAuxFront = [...this.upAuxFront];
    obj.upAuxRear = [...this.upAuxRear];
    obj.upMainFront = [...this.upMainFront];
    obj.upMainRear = [...this.upMainRear];
    return obj;
  }

  equals(other: HallCallEligibilityMessageT): boolean {
    if (this.configIndex !== other.configIndex) return false;
    if (this.controllerIndex !== other.controllerIndex) return false;
    if (this.downAuxFront.length !== other.downAuxFront.length) return false;
    for (let i = 0; i < this.downAuxFront.length; i++) {
      if (this.downAuxFront[i] !== other.downAuxFront[i]) return false;
    }
    if (this.downAuxRear.length !== other.downAuxRear.length) return false;
    for (let i = 0; i < this.downAuxRear.length; i++) {
      if (this.downAuxRear[i] !== other.downAuxRear[i]) return false;
    }
    if (this.downMainFront.length !== other.downMainFront.length) return false;
    for (let i = 0; i < this.downMainFront.length; i++) {
      if (this.downMainFront[i] !== other.downMainFront[i]) return false;
    }
    if (this.downMainRear.length !== other.downMainRear.length) return false;
    for (let i = 0; i < this.downMainRear.length; i++) {
      if (this.downMainRear[i] !== other.downMainRear[i]) return false;
    }
    if (this.upAuxFront.length !== other.upAuxFront.length) return false;
    for (let i = 0; i < this.upAuxFront.length; i++) {
      if (this.upAuxFront[i] !== other.upAuxFront[i]) return false;
    }
    if (this.upAuxRear.length !== other.upAuxRear.length) return false;
    for (let i = 0; i < this.upAuxRear.length; i++) {
      if (this.upAuxRear[i] !== other.upAuxRear[i]) return false;
    }
    if (this.upMainFront.length !== other.upMainFront.length) return false;
    for (let i = 0; i < this.upMainFront.length; i++) {
      if (this.upMainFront[i] !== other.upMainFront[i]) return false;
    }
    if (this.upMainRear.length !== other.upMainRear.length) return false;
    for (let i = 0; i < this.upMainRear.length; i++) {
      if (this.upMainRear[i] !== other.upMainRear[i]) return false;
    }
    return true;
  }
}

export function verifyHallCallEligibilityMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "down_aux_front");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "down_aux_rear");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "down_main_front");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 14, "down_main_rear");
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 16, "up_aux_front");
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 18, "up_aux_rear");
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 20, "up_main_front");
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 22, "up_main_rear");
  } finally {
    verifier.popDepth();
  }
}
